import BlankGift from '@components/blank/BlankGift';
import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import useRegisterByImage from './hooks/useRegisterByImage';

function GiftRegisterFragment() {
    const { t } = useTranslation('gift');
    const { push } = useFlow();
    const { handleSelectImage } = useRegisterByImage();

    return (
        <Container as='section' align='center' justify='center' spacing={4}>
            <BlankGift type='REGISTER' />
            <Column spacing={2} align='center'>
                <Text as='h2' size='title' fontWeight='bold' color={colors.textSecondary}>
                    {t('newGift.prompt')}
                </Text>
                <Text size='title' fontWeight='regular' color={colors.textSecondary} align='center'>
                    {t('newGift.description')}
                </Text>
            </Column>
            <Column spacing={2} align='center' fullWidth>
                <Button size='medium'
                    fullWidth
                    onClick={handleSelectImage}
                    id='register-gift-by-image-button'>
                    {t('newGift.loadImage')}
                </Button>
                <ManualButton type='button'
                    onClick={() => push('RegisterGiftActivity', {})}
                    id='register-gift-by-code-button' >
                    {t('newGift.barcodeTitle')}
                </ManualButton>
            </Column>
        </Container>
    );
}

const Container = styled(Column)`
    min-height: 500px;
    padding: var(--spacing-6) var(--spacing-4);
`;

const ManualButton = styled.button`
    width: 100%;
    min-height: 28px;
    padding: var(--spacing-1) var(--spacing-4);
    font-weight: 500;
    line-height: 1.4;
    background: transparent;
    color: ${colors.gray7};
    font-size: 12px;
    &:focus-visible { outline: 2px solid ${colors.primary}; }
`;

export default GiftRegisterFragment;
